import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const myLibrarySelector = state => state.myLibrary
const placeholder = localize('my_library_top_bar_search_placeholder')

const myLibraryLessonsPickerModalViewSelector = createSelector(
	[myLibrarySelector],
	myLibrary => ({

		folderName: myLibrary.folderName,
		placeholder,
	})
)

export default myLibraryLessonsPickerModalViewSelector
